// extracted by mini-css-extract-plugin
module.exports = {"odRankWrapper":"ODRank_odRankWrapper__3U0_-","odRankTitle":"ODRank_odRankTitle__34t5n","btnFunctional":"ODRank_btnFunctional__3oIWV"};